<template>
  <div class="main-block">
    <div class="row">
      <div class=" col-lg-4 col-sm-12 col-xs-12">
        <Input v-model="config.unitName" form-group-id="Unit" placeholder="Unit" :required="true" />
      </div>
      <div class=" col-lg-4 col-sm-12 col-xs-12">
        <Input v-model="config.unitValue" form-group-id="Value" placeholder="Value" :required="true" type="number" />
      </div>
      <div class=" col-lg-4 col-sm-12 col-xs-12">
        <Input v-model="config.unitFieldName" form-group-id="Number field name" placeholder="Number field name" :required="true" />
      </div>
    </div>
  </div>
</template>

<script>
import Input from '../../../../common/input';

let timeoutID = null;

export default {
  name: 'FormulaValue',
  components: {
    Input,
  },
  props: {
    values: {
      type: Object,
      default: () => {},
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      config: {
        unitName: '',
        unitValue: '',
        unitFieldName: '',
      },
    };
  },
  watch: {
    config: {
      handler: function (newValue) {
        this.handleChange(newValue);
      },
      deep: true,
    },
  },
  created() {
    this.config = Object.assign({}, this.values);
  },
  methods: {
    timeoutForUpdate(fn) {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
      setTimeout(() => {
        fn();
      }, 500);
    },
    handleChange(value) {
      this.timeoutForUpdate(() => this.onChange(value));
    },
  },
};
</script>

<style scoped lang="scss"></style>
